import {ChangeDetectorRef, Component, AfterViewChecked} from '@angular/core';
import {filter, Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {
  sideNavWeeksList
} from "../../../page-modules/behavior-tracker/core/behavior-tracker.selectors";
import {
  ClearSideNavWeeksList,
  FetchSideNavWeeksListRequest
} from "../../../page-modules/behavior-tracker/core/behavior-tracker.actions";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../shared/services/common.service";
import {
  questionnairesList
} from "../../../page-modules/questionnaire/core/questionnaires.selectors";
import {
  FetchQuestionnairesListRequest
} from "../../../page-modules/questionnaire/core/questionnaires.actions";
import {selectedUserProfile} from "../../../shared/core/shared.selectors";
import {
  ClearSelectedUserData,
  FetchProfileByUserIdRequest,
} from "../../../shared/core/shared.actions";

import {
  clientAdminConfig,
  clientConfig,
  coachConfig,
  groupConfig,
  memberConfig,
  superAdminConfig
} from './sidenav.config';
import {
  FetchGroupNameRequest
} from "../../../page-modules/group-details/core/group-details.actions";
import {
  clientDetails,
  clientName
} from "../../../page-modules/client-details/core/client-details.selector";
import {
  groupName
} from "../../../page-modules/group-details/core/group-details.selector";
import * as moment from "moment";
import {
  FetchClientNameRequest
} from "../../../page-modules/client-details/core/client-details.actions";
import {SideNavWeekList} from "../../../../models/side-nav-week-list";
import {roles} from "../../../shared/constants/common.constants";
import * as _ from "lodash";

@Component({
  selector: 'app-sidenav',
  templateUrl: './super-admin-sidenav.component.html',
  styleUrls: ['./super-admin-sidenav.component.css']
})
export class SuperAdminSidenavComponent implements AfterViewChecked {
  groupName = '';
  groupStartedOn = '';
  groupNameLoader = false;
  memberName = '';
  memberAge: number = null;
  memberNameLoader = false;
  memberId = null;
  clientName = '';
  clientNameLoader = false;
  memberGender = "";
  params: any = {};
  selectedClientId: number;
  selectedClientAdminId: number;
  selectedGroupId: number;
  selectedCoachId: number;
  selectedMemberId: number;
  showClientMenu: boolean;
  showClientAdminMenu: boolean;
  showCoachMenu: boolean;
  showGroupMenu: boolean;
  showMemberMenu: boolean;
  config: any[] = [];
  superAdminConfig: any[] = superAdminConfig;
  clientConfig: any[] = clientConfig;
  clientAdminConfig: any[] = clientAdminConfig;
  coachConfig: any[] = coachConfig;
  groupConfig: any[] = groupConfig;
  memberConfig: any[] = memberConfig;
  memberRole: number;
  clientId: number | undefined;
  groupId: number | undefined;
  sideNavWeeksListData: SideNavWeekList;
  isFirstPage: boolean = true;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private shouldScrollToSelected = false;
  private lastExpandedKey: string = null;

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.setSidenavConfig();


    this.store.select(selectedUserProfile)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.memberNameLoader = data.loading;
      });

    this.store.select(selectedUserProfile)
      .pipe(
        takeUntil(this.onDestroy),
        filter(data => !!data.profile)
      )
      .subscribe(data => {
        if (data.profile) {
          this.memberId = data.profile?.id;
          this.memberName = `${data.profile?.firstName} ${data.profile?.lastName}`;
          this.memberAge = moment().diff(data.profile?.dob, 'years');
          this.memberRole = data.profile?.role
          this.memberGender = data.profile?.gender && data.profile?.gender['value'] || '';
          this.clientId = data.profile?.clientId
          this.groupId = data.profile.role === roles["adult"] ? -1 : data?.profile?.groupId;
          this.setSidenavConfig();
        }
      });

    this.commonService.requestedResourceId.pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.selectedGroupId = null;
        this.selectedCoachId = null;
        this.selectedMemberId = null;
        this.selectedClientId = null;
        this.selectedClientAdminId = null;

        if (data[0] && data[1] && data[1] > 0) {
          switch (data[0]) {
            case "clientId":
              this.selectedClientId = data[1];
              break;
            case "clientAdminId":
              this.selectedClientAdminId = data[1];
              break;
            case "groupId":
              this.selectedGroupId = data[1];
              break;
            case "coachId":
              this.selectedCoachId = data[1];
              break;
            case "memberId":
              this.selectedMemberId = data[1];
              break;
            default:
              break;
          }
        }

        this.setSidenavConfig();
      });

    this.store
      .select(sideNavWeeksList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {

        let behaviorTrackerIndex = this.config?.map((e) => e.key)
          .indexOf('behaviorTracker');
        let journalIndex = this.config?.map((e) => e.key).indexOf('journal');

        if (behaviorTrackerIndex > -1) {
          this.config[behaviorTrackerIndex].children = [
            {
              id: -1,
              weekNumber: -1,
              heading: 'Summary',
              subHeading: '',
              isSelected: true
            },
            ...(JSON.parse(JSON.stringify(data.list)))
          ];
          
          // Trigger scroll if BT is expanded and we have a selected week/Summary
          const {queryParams} = this.route.snapshot;
          if (this.config[behaviorTrackerIndex].isExpanded && queryParams && queryParams['weekNumber'] !== undefined) {
            const weekNumber = Number(queryParams['weekNumber']);
            this.config[behaviorTrackerIndex].children = this.config[behaviorTrackerIndex].children.map(eachChild => {
              eachChild.isSelected = eachChild[this.config[behaviorTrackerIndex].queryParamKey] === weekNumber;
              return eachChild;
            });
            this.shouldScrollToSelected = true;
            this.lastExpandedKey = this.config[behaviorTrackerIndex].key;
          }
        }

        if (journalIndex > -1) {
          this.config[journalIndex].children = [
            ...(JSON.parse(JSON.stringify(data.list)))
          ];
        }

        this.triggerSidenavSelection();
        // Trigger scroll for BT if week is selected
        const {queryParams} = this.route.snapshot;
        if (behaviorTrackerIndex >= 0 && queryParams && queryParams['weekNumber'] !== undefined) {
          this.shouldScrollToSelected = true;
          this.lastExpandedKey = this.config[behaviorTrackerIndex].key;
        }
      });

    this.store
      .select(questionnairesList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        let index = this.config?.map((e) => e.key).indexOf('questionnaires');

        if (index > -1) {
          this.config[index].children = [
            {
              id: -1,
              questionnaireId: -1,
              heading: 'Summary',
              subheading: '',
              isSelected: true
            },
            ...(JSON.parse(JSON.stringify(data.list)))
          ];
        }

        this.triggerSidenavSelection();
      });


    this.store.select(groupName)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.groupNameLoader = data.loading;
        if (data) {
          this.groupName = data.name;
          this.groupStartedOn = moment(data.startDate).format('LL');
        }

        this.cdRef.detectChanges();
      });

    this.store.select(clientName).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data) {
          this.clientName = data?.name;
        }
      });

    this.store.select(clientDetails).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.clientNameLoader = data.loading;
        if (data.details) {
          this.clientName = data.details?.name;
        }
      })

    this.commonService.urlParams
      .pipe(
        takeUntil(this.onDestroy),
        filter((data) => !_.isEqual(data?.params, this.params))
      )
      .subscribe(data => {
        this.params = data?.params || {};

        if (this.params?.groupId) {
          this.store.dispatch(FetchGroupNameRequest({
            payload: {
              groupId: this.params.groupId
            }
          }));
        }

        if (this.params?.clientId) {
          this.store.dispatch(FetchClientNameRequest({
            payload: {
              clientId: this.params.clientId
            }
          }));
        }

        const url = this.router.url.split('?')[0];

        let userId = this.params?.clientAdminId ||
                     this.params?.coachId ||
                     this.params?.memberId;

        if (userId && !url.includes('profile')) {
          this.store.dispatch(FetchProfileByUserIdRequest({
            payload: {userId}
          }))
        }

        if (!userId) {
          this.store.dispatch(ClearSelectedUserData());
        }
      });

    this.commonService.urlParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.triggerSidenavSelection();
      });
  }

  triggerSidenavSelection() {
    const url = this.router.url.split('?')[0];

    const urlsList = this.config?.map((e) => e.linkedUrls(this.params));

    let index = -1;

    for (let x = 0; x < urlsList.length; x++) {
      for (let y = 0; y < urlsList[x].length; y++) {
        if (url === urlsList[x][y]) {
          index = x;
          break;
        }
      }
      if (index > -1) {
        break;
      }
    }

    this.deselectAll();

    if (index === -1) {
      index = 0;
    }

    if (this.config[index]?.isExpandable) {
      const {queryParams} = this.route.snapshot;
      this.expandSidenavItem(this.config[index].key, queryParams);
      // Trigger scroll for BT
      if (this.config[index].key === 'behaviorTracker' && queryParams && queryParams['weekNumber'] !== undefined) {
        this.shouldScrollToSelected = true;
        this.lastExpandedKey = this.config[index].key;
      }
    } else {
      this.selectSidenavItem(this.config[index].key);
    }


  }

  expandSidenavItem(key, queryParams?) {
    const index = this.config.map((e) => e.key).indexOf(key);
    const isBehaviorTracker = key === 'behaviorTracker';

    if (this.config[index].isExpanded) {
      this.config[index].isExpanded = false;
      this.cdRef.detectChanges();
      return;
    }

    if (queryParams) {
      if (queryParams[this.config[index].queryParamKey] !== undefined) {
        const weekNumber = Number(queryParams[this.config[index].queryParamKey]);
        
        // Check if the week exists in the children list
        const weekExists = this.config[index].children.some(
          child => child[this.config[index].queryParamKey] === weekNumber
        );
        
        // If week doesn't exist in menu and it's BT, allow closing but keep BT highlighted
        if (isBehaviorTracker && !weekExists && weekNumber !== -1) {
          // Week is beyond the limit, allow BT to be closed but keep it highlighted (active green)
          this.config[index].isSelected = true;
          this.config[index].isExpanded = false;
          this.cdRef.detectChanges();
          return;
        }
        
        this.config[index].children = this.config[index].children.map(eachChild => {
          eachChild.isSelected = eachChild[this.config[index].queryParamKey] === weekNumber;
          return eachChild;
        });
        
        // When week/Summary exists in menu, BT parent should NOT be highlighted
        // Only highlight BT parent when week doesn't exist (handled with early return above)
        if (isBehaviorTracker) {
          this.config[index].isSelected = false;
        }
      } else if (this.config[index]?.key !== 'journal') {
        this.router.navigate([], {
          queryParams: {
            [this.config[index].queryParamKey]: -1
          },
          replaceUrl: true
        })
      }


      this.cdRef.detectChanges();
    }

    this.config[index].isExpanded = true;
    
    // Trigger scroll to selected item for BT
    if (isBehaviorTracker) {
      this.shouldScrollToSelected = true;
      this.lastExpandedKey = key;
    }
    
    this.cdRef.detectChanges();
  }

  selectSidenavItem(key) {
    const url = this.router.url.split('?')[0];

    const urlsList = this.config?.map((e) => e.linkedUrls(this.params));

    let index = -1;

    for (let x = 0; x < urlsList.length; x++) {
      for (let y = 0; y < urlsList[x].length; y++) {
        if (url === urlsList[x][y]) {
          index = x;
          break;
        }
      }
      if (index > -1) {
        break;
      }
    }

    if (this.config[index]) {
      this.config[index].isSelected = true;
      if (this.config[index].isExpandable) {
        this.config[index].isExpanded = true;
      }
    }


    this.cdRef.detectChanges();
  }

  navigate(option) {
    const link = option.link({
      ...(this.selectedClientAdminId ? {clientAdminId: this.selectedClientAdminId} : {}),
      ...(this.selectedClientId ? {clientId: this.selectedClientId} : {}),
      ...(this.selectedGroupId ? {groupId: this.selectedGroupId} : {}),
      ...(this.selectedMemberId ? {memberId: this.selectedMemberId} : {}),
      ...(this.selectedCoachId ? {coachId: this.selectedCoachId} : {}),
    });

    if (option.isExpandable && this.router.url.toString()
      .split('?')[0] === link) {
      this.expandSidenavItem(option.key);
      return;
    }

    this.router.navigate([link]);
  }

  selectChildNavigation(eachConfig, childIndex) {
    const link = eachConfig.link({memberId: this.params.memberId});

    let route = [];
    if (this.router.url.toString().split('?')[0] !== link) {
      route = [link]
    }
    this.router.navigate(route, {
      queryParams: {
        [eachConfig['queryParamKey']]: eachConfig.children[childIndex][eachConfig['queryParamKey']]
      }
    });
  }

  deselectAll() {
    this.config = this.config?.map(e => {
      if (e.isExpandable) {
        e.isExpanded = false;
        e.children = e.children.map(ce => {
          ce.isSelected = false;
          return ce;
        });
      } else {
        e.isSelected = false;
      }

      return e;
    });
  }

  setSidenavConfig() {
    this.showClientMenu = false;
    this.showClientAdminMenu = false;
    this.showCoachMenu = false;
    this.showGroupMenu = false;
    this.showMemberMenu = false;

    if (this.selectedMemberId) {
      this.showMemberMenu = true;
      this.fetchSideNavWeeksList();
      this.store.dispatch(FetchQuestionnairesListRequest({userId: this.selectedMemberId}));
      this.config = this.memberConfig;
      return;
    }

    if (this.selectedGroupId) {
      this.showGroupMenu = true;
      this.config = this.groupConfig;
      return;
    }

    if (this.selectedCoachId) {
      this.showCoachMenu = true;
      this.config = this.coachConfig;
      return;
    }

    if (this.selectedClientAdminId) {
      this.showClientAdminMenu = true;
      this.config = this.clientAdminConfig;
      return;
    }

    if (this.selectedClientId) {
      this.showClientMenu = true;
      this.config = this.clientConfig;
      return;
    }

    this.config = this.superAdminConfig;
  }

  fetchSideNavWeeksList(pageNumber = 1, limit = 52) {
    if (!this.params.memberId || (this.params.memberId && (this.groupId === undefined))) {
      return;
    }

    const payload = {
      groupId: this.groupId,
      ...(this.params.memberId ? {forUserId: this.params.memberId} : {}),
      pageNumber,
      limit
    }

    if (payload.groupId) {
      this.store.dispatch(FetchSideNavWeeksListRequest({payload}));
    } else {
      this.store.dispatch(ClearSideNavWeeksList());
    }

  }

  onScroll() {
    if (this.sideNavWeeksListData?.hasNext && !this.sideNavWeeksListData?.loading) {
      this.fetchSideNavWeeksList(this.sideNavWeeksListData.pageNumber + 1, this.sideNavWeeksListData.limit);
      this.isFirstPage = false;
    }
  }


  ngAfterViewChecked() {
    if (this.shouldScrollToSelected) {
      this.scrollToSelectedItem();
      this.shouldScrollToSelected = false;
    }
  }

  scrollToSelectedItem() {
    // Wait for the next tick to ensure DOM is updated
    setTimeout(() => {
      const behaviorTrackerIndex = this.config.map((e) => e.key)
        .indexOf('behaviorTracker');
      
      if (behaviorTrackerIndex === -1 || !this.config[behaviorTrackerIndex].isExpanded) {
        return;
      }

      // Find the selected child
      const selectedChild = this.config[behaviorTrackerIndex].children.find(
        child => child.isSelected
      );

      if (!selectedChild) {
        return;
      }

      // Find the children-section element for BT by looking for the specific config
      const allParentItems = document.querySelectorAll('.parent-sidenav-item');
      let targetSection: HTMLElement = null;

      allParentItems.forEach((parentItem: HTMLElement) => {
        const expandableItem = parentItem.querySelector('.sidenav-item.expandable');
        if (expandableItem && expandableItem.textContent.trim().includes('Behavior Tracker')) {
          const section = parentItem.querySelector('.children-section') as HTMLElement;
          if (section && section.offsetParent !== null) { // Check if visible
            targetSection = section;
          }
        }
      });

      if (!targetSection) {
        return;
      }

      // Find the selected child element
      const childWrappers = Array.from(targetSection.querySelectorAll('.sidenav-item-child-wrapper')) as HTMLElement[];
      let selectedElement: HTMLElement = null;

      childWrappers.forEach((wrapper: HTMLElement) => {
        const child = wrapper.querySelector('.sidenav-item-child.selected');
        if (child) {
          selectedElement = wrapper;
        }
      });

      if (selectedElement && targetSection) {
        const scrollContainer = targetSection;
        const currentScrollTop = scrollContainer.scrollTop;
        const elementTop = selectedElement.offsetTop;
        const elementHeight = selectedElement.offsetHeight;
        const containerHeight = scrollContainer.clientHeight;
        const elementBottom = elementTop + elementHeight;
        
        // Calculate visible area
        const visibleTop = currentScrollTop;
        const visibleBottom = currentScrollTop + containerHeight;
        
        // Check if element is already fully visible
        const isFullyVisible = elementTop >= visibleTop && elementBottom <= visibleBottom;
        
        if (!isFullyVisible) {
          let targetScrollTop = currentScrollTop;
          const scrollOffset = 5; // Offset to prevent extra 5px scrolling
          
          // If element is above visible area, scroll to show it at the top
          if (elementTop < visibleTop) {
            targetScrollTop = elementTop + scrollOffset;
          }
          // If element is below visible area, scroll to show it at the bottom
          else if (elementBottom > visibleBottom) {
            targetScrollTop = elementBottom - containerHeight - scrollOffset;
          }
          
          // Ensure we don't scroll beyond bounds
          const maxScroll = scrollContainer.scrollHeight - containerHeight;
          targetScrollTop = Math.max(0, Math.min(targetScrollTop, maxScroll));
          
          // Only scroll if we need to move from current position
          if (Math.abs(targetScrollTop - currentScrollTop) > 1) {
            // Use 'auto' for instant scroll to avoid visible scrolling from top
            scrollContainer.scrollTo({
              top: targetScrollTop,
              behavior: 'auto'
            });
          }
        }
      }
    }, 100);
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
    this.cdRef.detach();
  }

  protected readonly roles = roles;
}
